import type { PageComponent } from '../../router'
import { ShufflePageController } from './ShufflePageController'
import { shufflePageTemplate } from './shufflePageTemplates'

/** Mounts once so filters and the prepared sample survive route changes. */
const ShufflePage: PageComponent = {
	async mount(context) {
		const { containerEl, user, signal } = context
		if (!user) throw new Error('Authentication required')
		containerEl.innerHTML = shufflePageTemplate()
		const root = containerEl.querySelector<HTMLElement>('#shuffle-section')
		if (!root) throw new Error('Missing shuffle page')

		const controller = new ShufflePageController(root, user, context)
		signal.addEventListener('abort', () => controller.dispose(), {
			once: true,
		})
		await controller.ready
		signal.throwIfAborted()
		return controller
	},
}

export default ShufflePage
